module.exports = __webpack_public_path__ + "static/img/ic-40-keys.13ff440.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/giveaway/260611/ic-40-keys.svg
// module id = ZJAV
// module chunks = 2